<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
  <dx-text-area
  formControlName="instructions"
  [label]="'entity.workProcedure.step.instructions' | translate | ucfirst"
  formField
  required
  ></dx-text-area>
  <dx-number-box
  formControlName="instructionsValue"
  [label]="'entity.workProcedure.step.instructionsValue' | translate | ucfirst"
  formField
  ></dx-number-box>

  <dx-lookup
    [gsResource]="checkpointsRes"
    valueExpr="id"
    displayExpr="name"
    formControlName="checkpointId"
    [label]="'common.checkpoint' | translate | ucfirst"
    [placeholder]="'common.checkpoint' | translate | ucfirst"
    (onSelectionChanged)="onCheckpointSelectionChanged($event)"
  />

  <dx-tag-box
    *ngIf="isSelectionType"
    formControlName="defaultValues"
    [items]="defaultValuesChoices"
    [acceptCustomValue]="false"
    [searchEnabled]="true"
    [label]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
    formField
  ></dx-tag-box>

  <dx-text-box
    *ngIf="isTextType"
    formControlName="defaultTextValue"
    [label]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
    formField
  ></dx-text-box>

  <dx-text-area
    *ngIf="isLongTextType"
    formControlName="defaultLongTextValue"
    [label]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
    formField
  ></dx-text-area>

  <dx-number-box
    *ngIf="isNumericType"
    formControlName="defaultNumericValue"
    [label]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
    formField
  ></dx-number-box>

  <dx-date-box
    *ngIf="isDateType"
    type="date"
    formControlName="defaultDateValue"
    [label]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
    formField
  ></dx-date-box>

  <dx-date-box
    *ngIf="isTimeType"
    type="time"
    formControlName="defaultTimeValue"
    [label]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
    formField
  ></dx-date-box>

  <div class="stepsAddSwitch">
    <dx-switch
      *ngIf="isBooleanType"
      formControlName="defaultBooleanValue"
      [label]="'entity.workProcedure.step.defaultValues' | translate | ucfirst"
      formField
    />
  </div>

  <div class="stepsAddSwitch">
    <dx-switch
      formControlName="required"
      [label]="'entity.workProcedure.step.required' | translate | ucfirst"
      formField
    />
  </div>
</form>
